<template>
    <div class="cc-payments">
        <div class="cc-payments__header">
            <div class="cc-payments__title cc-title cc-title--section">{{ translations['Payments'] }}</div>
            <a class="cc-payments__change cc-link" v-if="selectedPayment" @click="unsetPayment">{{ translations['Change payment'] }}</a>
        </div>
        <div class="cc-payments__main" v-if="display">
            <payment v-for="payment in sortedPayments" v-bind:key="payment.uniqueName" :payment="payment"/>
        </div>
        <div class="cc-payments__alerts" v-if="!display">
            <div class="cc-alert cc-alert--information">{{ translations['Please select carrier to show available payments'] }}</div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import Payment from "./Payment";

    export default {
        components: {
            Payment,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                payments: state => state.payments,
                paymentExtensions: state => state.paymentExtensions,
                user: state => state.user,
                selectedCarrier: state => state.selectedCarrier,
                selectedPayment: state => state.selectedPayment,
            }),
            display: function () {
                return this.user.deliveryAddress.country && this.selectedCarrier && this.payments && this.payments.length;
            },
            sortedPayments: function () {
                const that = this;
                let sorted = [];

                this.payments.forEach(function (payment) {
                    if (payment.name in that.paymentExtensions) {
                        payment.position = parseInt(that.paymentExtensions[payment.name].position);
                    } else {
                        payment.position = 0;
                    }

                    sorted.push(payment);
                });

                return sorted.sort(function (a, b) {
                    return a.position > b.position ? 1 : -1;
                });
            },
        },
        methods: {
            unsetPayment: function () {
                this.$store.dispatch('SELECT_PAYMENT', null);
            },
        },
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/payments";
</style>
